import dayjs from "dayjs";
import { useDatetime } from "../../../../../utils/useDatetime";
import { AllergiesActions } from "./AllergiesActions";
import { useDict } from "../../../../../utils/useDict";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { EhrMobileGenericSection } from "../../mobile/EhrMobileGenericSection";

export function Allergies({
  data,
  title,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  const { formatToDDMMYYYY } = useDatetime;

  const columns = [
    { column: "Subtancia", rowName: "substance" },
    { column: "Categoria", rowName: "category" },
    { column: "Status de verificação", rowName: "verificationStatus" },
    { column: "Status clínico", rowName: "clinicalStatus" },
    { column: "Criticidade", rowName: "criticality" },
    { column: "Data", rowName: "date" },
  ];

  const rowData = data?.[0]?.entry?.map((el: any) => ({
    encounterId: el?.resource?.encounter?.reference?.split("/")?.[1],
    criticality: useDict.criticality[el?.resource?.criticality] || "-",
    category: useDict.category[el?.resource?.category?.[0]] || "-",
    verificationStatus:
      useDict.verificationStatus[
        el?.resource?.verificationStatus?.coding?.[0]?.code
      ] || "",
    clinicalStatus:
      useDict.clinicalStatus[el?.resource?.clinicalStatus?.coding?.[0]?.code] ||
      "",
    substance: el.resource?.code?.text,
    date: formatToDDMMYYYY(dayjs(el?.resource?.recordedDate)),
  }));

  return (
    <EhrMobileGenericSection
      title={title}
      columns={columns}
      rows={rowData ?? []}
      actions={
        access?.type === "patient"
          ? undefined
          : (rowData: any) => (
              <AllergiesActions
                row={rowData}
                openVisualizer={openVisualizer}
                verifyVisualizer={verifyVisualizer}
              />
            )
      }
    />
  );
}
